module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_7005.605be6e6.png";